<template>
    <div class="FooterTY-cmp">
		<div class="footer">
			<div class="footer-top">
				<div class="edit-container">
					<div class="row">
						<div class="col-xs-12 col-md-3">
							<div class="footer-logo"><a href="http://www.gdhhotels.com/index.html"><img src="../../assets/images/yh/icon/gdhmlogo.png" ></a></div>
							<div class="links clearfix">
								<a href="http://www.gdhhotels.com/about/hotel-alliance.html">业务拓展</a>
<!--								<a href="http://www.gdhhotels.com/about/group-news1.html">集团新闻</a>-->
								<a href="http://www.gdhhotels.com/about/join-us1.html">人才招聘</a>
								<!-- <a href="#">手机客户端</a> -->
							</div>
						</div>
						<div class="col-xs-12 col-md-9">
							<div class="city-links">
								<div class="title">城市分布</div>
								<div class="cont clearfix">
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0001">深圳粤海酒店</a>-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0002">上海粤海酒店</a>-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0003">珠海粤海酒店</a>-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0004">郑州粤海酒店</a>-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0005">珠海唐邑酒店</a>-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0007">香港粤海酒店</a>-->
<!--&lt;!&ndash;									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0016">深圳学苑大厦</a>&ndash;&gt;-->
<!--&lt;!&ndash;									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0017">粤海之星深圳东湖店</a>&ndash;&gt;-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0013">楚天粤海国际大酒店</a>-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0010">佛山千灯湖酒店</a>-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0006">香港粤海华美湾际酒店</a>-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0015">镇江佰润粤海国际酒店</a>-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0018">海口兴泰粤海酒店</a>-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0019">张家港中联粤海国际酒店</a>-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0020">大连星海假日酒店</a>-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0014">西安唐隆国际酒店</a>-->
<!--&lt;!&ndash;									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0031">西宁长江粤海国际饭店</a>&ndash;&gt;-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0032">广州德文家粤海酒店</a>-->
<!--									<a href="http://booking.gdhhotels.com/pc/search-hotel?hotelId=0033">商丘椒乡粤海酒店</a>-->
									<a v-for="(data,index) in hotelList" :key="index" :href="hostUrl+'/pc/search-hotel?hotelId='+data.code">{{data.name}}</a>
								</div>
							</div>
						</div>

					</div>
				</div>

			</div>
			<div class="footer-bottom">
				<div class="edit-container">
					<div class="links">
						<a href="http://www.gdhhotels.com/usage.html">使用条款</a>
						<a href="http://www.gdhhotels.com/privacy.html">隐私声明</a>
						<!-- <a href="#">网站地图</a> -->
						<a href="http://www.gdhhotels.com/about/contact-us.html">联系方式</a>
					</div>
					<div class="copyright">
						<span>版权所有 粤海国际酒店管理（中国）有限公司</span>
						<span>
							<a href="https://beian.miit.gov.cn" target="_blank">ICP备案号 粤ICP备06050136号</a>
						</span>
						<!-- <span><a href="#">网站地图</a></span> -->
						<span>
							<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030302002010" style="display:inline-block;text-decoration:none;">
								<img src="../../assets/images/yh/beian.png" style="display: inline-block;vertical-align: middle;"/>
								粤公网安备 44030302002010号
							</a>
						</span>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import axios from "axios"
    export default {
        name: "FooterYH",
		data(){
        	return{
				hotelList: [],
				hostUrl: ""
			}
		},
		created(){
			this.hostUrl = window.location.protocol + '//' + window.location.host
			this.getHotelList();
		},
		methods: {
			getHotelList() {
				axios.post("/gk/hotel/service/queryHotelList", {}, this.$token).then(res => {
					if (res.data.status == 200) {
						let hotelArr = res.data.data;
						for(let x of hotelArr) {
							if(x.hotelInfoList && x.hotelInfoList.length > 0) {
								for(let y of x.hotelInfoList){
									this.hotelList.push(y)
								}
							}
						}
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(error => {
					console.log(error);
				});
			},
		}
    }
</script>

<style scoped>
	@media (max-width: 1600px) and (min-width: 1280px){
		.footer .edit-container {
			width: 1080px;
		}
		.footer-top .city-links {
			margin-top: 0;
			margin-left: 50px;
		}
	}
</style>



// WEBPACK FOOTER //
// FooterYH.vue?51f9f229